module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-b8c54752.png";